import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    width: 300,
    height: 200,
    cursor: 'pointer',
    border: `1px dashed ${theme.borderColor}`,
    backgroundColor: theme.backgroundColor,
    borderRadius: 5
  },
  active: {

  },
  clickArea: {
    width: '100%',
    padding: theme.spacing(2),
    textAlign: 'center',
    marginTop: 50,
  },
  fullWidth: {
    width: '100%'
  }
}))

export {
  useStyles
}
